import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'common/ui/tooltip';
import { HelpCircle } from 'lucide-react';
import { ReactNode } from 'react';

interface LabelTooltipProps {
  label: ReactNode
  tooltipContent?: ReactNode
  className?: string
}

export function LabelTooltip({
  label,
  tooltipContent,
  className,
}: LabelTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`flex items-center gap-1 ${className || ''}`}>
            {label}
            <HelpCircle className="size-3 mb-0.5 cursor-help" />
          </div>
        </TooltipTrigger>
        <TooltipContent className="font-normal">
          {tooltipContent}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
